import { Button, Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

interface Props {
  show: boolean;
  setShow: (show: boolean) => void;
}

function CartAlertModal({ show, setShow }: Props) {
  const history = useHistory();

  const handleCloseModal = () => {
    setShow(false);
  };

  return (
    <Modal show={show} onHide={handleCloseModal} animation={false} centered={true}>
      <Modal.Body>
        <h4 className="text-center mb-0">Finalizar compra?</h4>
        <small className="mt-2 d-flex justify-content-center text-muted">
          Prefere continuar comprando ou ir para o carrinho?
        </small>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex justify-content-around w-100 mt-2 mb-2">
          <Button
            variant="outline-secondary"
            onClick={() => {
              setShow(false);
              history.push('/cart');
            }}
            style={{ height: '50px', borderRadius: 7, fontWeight: 700 }}
          >
            Ir para carrinho
          </Button>

          <Button
            variant="primary"
            onClick={handleCloseModal}
            style={{ height: '50px', borderRadius: 7, fontWeight: 700 }}
          >
            Continuar comprando
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default CartAlertModal;
